var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 38,
    viewBox: "0 0 26 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3742_00000042003705170181869040000004972654268753914535_",
    transform: "translate(12 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3741_00000180367978527804765570000006689035975510939578_",
    transform: "translate(-12 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079_00000044149151196890558810000015392319240112575661_",
    d: "M2.11,26.138a1.22,1.22,0,1,1-2.44,0v-2.2a2.47,2.47,0,1,1,3.35-1.01,2.394,2.394,0,0,1-.9.94M-4.29,5.342a5.11,5.11,0,1,1,10.22,0v7.922H-8.66A3.338,3.338,0,0,0-12,16.6V30.669A3.329,3.329,0,0,0-8.67,34H10.66A3.338,3.338,0,0,0,14,30.669h0V16.6a3.331,3.331,0,0,0-3.34-3.331H9.9V5.072a9.075,9.075,0,0,0-18.15,0Z",
    transform: "translate(12 4)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpened);
export default __webpack_public_path__ + "static/media/door_opened.c302d908c5d50193f173cdddd482b67f.svg";
export { ForwardRef as ReactComponent };